import { canonicalize } from "./canonical.js";
import { hashString } from "./xxhash64.js";
import type { Brand } from "../ids.js";

export type StateHash = Brand<string, "StateHash">;

/** D2 — the checkpoint hash of any plain-data value. */
export function hashState(v: unknown): StateHash {
  return hashString(canonicalize(v)) as StateHash;
}

export { canonicalize } from "./canonical.js";
export { xxhash64, hashString } from "./xxhash64.js";
